import { gsap } from "gsap";


// gsap.registerPlugin(Flip, ScrollTrigger, ScrollToPlugin, TextPlugin);

const bsAnimation = (container) => {

    // WITH Timelines (cleaner, more versatile)
    var tl1 = gsap.timeline({ repeat: 0, repeatDelay: 1 });
    tl1.to("#homescreen", {
        yPercent: -42, ease: "power2.out",
        duration: 1.8
    }, 0.5);
    tl1.to("#homescreen", { yPercent: -37, duration: 0.8, ease: "power1.out" });
    tl1.to("#homescreen", { yPercent: -71, duration: 1.5, ease: "back.out(2)" }, "+=1.2");
    tl1.to("#homescreen", { yPercent: 0, duration: 1.9, ease: "back.out(0.5)" }, "+=0.7");

    var tl2 = gsap.timeline({ repeat: 0, repeatDelay: 1 });
    tl2.to("#creatures", {
        yPercent: -34, ease: "back.out(2)",
        duration: 2.8
    }, 1.5);
   
    var tl3 = gsap.timeline({ repeat: 0, repeatDelay: 1 });
    tl3.to("#aid", {
        yPercent: -12, ease: "power2.out",
        duration: 1.8
    }, 0.8);
    tl3.to("#aid", { yPercent: -24, duration: 1.2, ease: "power1.out" });
    tl3.to("#aid", { yPercent: -36, duration: 1.5, ease: "power1.out" }, "+=1.2");
    tl3.to("#aid", { yPercent: -42.69, duration: 1.9, ease: "back.out(2)" }, "+=0.7");


   
}

export default bsAnimation;